import React, { useEffect } from 'react';

function ClausePage({ onBack }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="clause-page">
      {/* Top Navigation Bar */}
      <div className="clause-top-bar">
        <div className="clause-back-btn" onClick={onBack}>
          <i className="bi bi-chevron-left"></i>
        </div>
        <div className="clause-title-text">Clause</div>
        <div className="clause-spacer"></div>
      </div>

      {/* Content Area */}
      <div className="clause-content">
        <div className="clause-section">
          <div className="clause-section-title">1. Start optimizing products</div>
          
          <div className="clause-subsection">
            <div className="clause-subsection-number">1.1</div>
            <div className="clause-subsection-text">
              In order to start the optimization of the application, a deposit of more than 101 USDT is required.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">1.2</div>
            <div className="clause-subsection-text">
              After product optimization is completed, users can withdraw all funds from the account. Additionally, users cannot request an account reset before receiving the withdrawal amount.
            </div>
          </div>
        </div>

        <div className="clause-section">
          <div className="clause-section-title">2. Funds</div>
          
          <div className="clause-subsection">
            <div className="clause-subsection-number">2.1</div>
            <div className="clause-subsection-text">
              All users' funds will be safely stored in their accounts and full withdrawals can be requested after all product optimizations are completed.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">2.2</div>
            <div className="clause-subsection-text">
              In order to avoid loss of funds, all application orders will be allocated by the system instead of manual allocation.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">2.3</div>
            <div className="clause-subsection-text">
              If there is an unexpected loss of funds, the platform will bear all losses.
            </div>
          </div>
        </div>

        <div className="clause-section">
          <div className="clause-section-title">3. Account security</div>
          
          <div className="clause-subsection">
            <div className="clause-subsection-number">3.1</div>
            <div className="clause-subsection-text">
              Please do not tell others your login password and withdrawal password. The platform does not assume any responsibility if any loss or damage occurs.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">3.2</div>
            <div className="clause-subsection-text">
              It is not recommended that users use birthdays, ID numbers, and mobile phone numbers to set withdrawal passwords or login passwords.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">3.3</div>
            <div className="clause-subsection-text">
              If you forget your login password or withdrawal password, please contact online customer service to reset it.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">3.4</div>
            <div className="clause-subsection-text">
              Confidentiality agreement between the user and the enterprise. The task completed on this platform is to obtain real-time real user data. The user needs to ensure the confidentiality of the task content and the platform.
            </div>
          </div>
        </div>

        <div className="clause-section">
          <div className="clause-section-title">4. Common applications</div>
          
          <div className="clause-subsection">
            <div className="clause-subsection-number">4.1</div>
            <div className="clause-subsection-text">
              VIP1 users will receive a 0.4% reward for each product they optimize.<br />
              VIP2 users will receive a 0.6% reward for each product they optimize.<br />
              VIP3 users will receive a 0.8% reward for each product they optimize.<br />
              VIP4 users will receive a 1.0% reward for each product they optimize.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">4.2</div>
            <div className="clause-subsection-text">
              After product optimization is completed, funds and commissions will be returned to the user account.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">4.3</div>
            <div className="clause-subsection-text">
              The system will randomly allocate orders based on the total amount in the user's account.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">4.4</div>
            <div className="clause-subsection-text">
              Once assigned to a user account, data cannot be canceled or skipped.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">4.5</div>
            <div className="clause-subsection-text">
              In order to protect the rights and interests of users, the application fee will be increased based on the total reimbursement amount to increase income.
            </div>
          </div>
        </div>

        <div className="clause-section">
          <div className="clause-section-title">5. Combination goods</div>
          
          <div className="clause-subsection">
            <div className="clause-subsection-number">5.1</div>
            <div className="clause-subsection-text">
              A combined application consists of 1 to 3 items. Users will not necessarily receive all three product programs, but the system will randomly distribute the products in the combination. Therefore, users are more likely to get 1 to 2 items.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">5.2</div>
            <div className="clause-subsection-text">
              The commission for combined orders is 15-100 times the commission for ordinary orders.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">5.3</div>
            <div className="clause-subsection-text">
              When acquiring an application portfolio, the flow of all funds will cease. When all included applications are completed, all funds will be returned to the user's account.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">5.4</div>
            <div className="clause-subsection-text">
              The system randomly allocates portfolio applications to user accounts based on the total balance of the user's account.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">5.5</div>
            <div className="clause-subsection-text">
              Portfolio applications assigned to a user account cannot be canceled or skipped.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">5.6</div>
            <div className="clause-subsection-text">
              Each product maintenance task is required to be completed by the user within 8 hours. If the task is not completed on time and the user fails to notify the merchant of the extension time, resulting in complaints from the merchant, the user shall bear the liability for breach of contract.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">5.7</div>
            <div className="clause-subsection-text">
              The initial account credit score is 100 points. If the work account is overdue for a long time, the system will deduct the corresponding credit score based on the overdue time. If the credit score of the work account is too low, resulting in the work account being frozen, the user needs to repair the credit score to 90 points to restore the normal operation of the work account.
            </div>
          </div>
        </div>

        <div className="clause-section">
          <div className="clause-section-title">6. Deposit</div>
          
          <div className="clause-subsection">
            <div className="clause-subsection-number">6.1</div>
            <div className="clause-subsection-text">
              The deposit amount is determined by the user. Since we cannot determine the customer's deposit amount, we recommend that customers make deposits based on their own circumstances or after becoming familiar with the platform.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">6.2</div>
            <div className="clause-subsection-text">
              If a user encounters a combined order and needs to make a deposit, they should deposit according to the negative balance shown on their account.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">6.3</div>
            <div className="clause-subsection-text">
              Before making a deposit, the customer needs to submit a deposit request to the online customer service and confirm the merchant's digital wallet address and amount.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">6.4</div>
            <div className="clause-subsection-text">
              The platform does not bear any responsibility if the money is deposited into the wrong digital wallet address.
            </div>
          </div>
        </div>

        <div className="clause-section">
          <div className="clause-section-title">7. Work with developers</div>
          
          <div className="clause-subsection">
            <div className="clause-subsection-number">7.1</div>
            <div className="clause-subsection-text">
              Different products will be updated to the platform every minute. If a product is occupied for a long time without promotion, the application data will not be uploaded to the system, thus affecting the data upload progress. In order to maintain the reputation of the merchant, users need to complete the task within 24 hours. If the task is not completed within the deadline, the merchant will file a complaint and the order will be frozen!
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">7.2</div>
            <div className="clause-subsection-text">
              In order for users to make prepayments, developers will provide digital wallet addresses.
            </div>
          </div>
        </div>

        <div className="clause-section">
          <div className="clause-section-title">8. Exit</div>
          
          <div className="clause-subsection">
            <div className="clause-subsection-number">8.1</div>
            <div className="clause-subsection-text">
              The withdrawal limit for VIP1 is 800, the withdrawal limit for VIP2 is 2,500USD, the withdrawal limit for VIP3 is 8,000USD, and the withdrawal limit for VIP4 is 100,000USD. If the account balance exceeds 100,000USD, please contact our online customer service to withdraw funds.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">8.2</div>
            <div className="clause-subsection-text">
              The full amount can be withdrawn after completing all application work.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">8.3</div>
            <div className="clause-subsection-text">
              If the product optimization process is suspended or abandoned, the work will be disqualified and no withdrawal or refund request can be made.
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">8.4</div>
            <div className="clause-subsection-text">
              We cannot process withdrawals without a user making a withdrawal request.
            </div>
          </div>
        </div>

        <div className="clause-section">
          <div className="clause-section-title">9. Business hours</div>
          
          <div className="clause-subsection">
            <div className="clause-subsection-number">9.1</div>
            <div className="clause-subsection-text">
              Platform business hours are from 9:30 to 21:30
            </div>
          </div>

          <div className="clause-subsection">
            <div className="clause-subsection-number">9.2</div>
            <div className="clause-subsection-text">
              The working hours of the online customer service center are from 9:30 to 21:30.
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="clause-footer">
          <p>The final right of interpretation belongs to Company Group</p>
        </div>
      </div>
    </div>
  );
}

export default ClausePage;

